import React from "react";
import VideoBox from "globals/videobox/VideoBox.react";
import Caption from "../../contentBlocks/Caption.react";
import SlideHeader from "../../contentBlocks/SlideHeader.react";
import PropTypes from "prop-types";
import SlideHeaderSidebar from "../../contentBlocks/SlideHeaderSidebar.react";
import { Grid } from "semantic-ui-react";
import { ComponentInputs } from "schema/FormSchema.react";

export default class VideoCaption extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            video: PropTypes.string,
            caption: PropTypes.string,
        }).isRequired,
        colors: PropTypes.shape({}).isRequired,
        slideId: PropTypes.number,
        mobileView: PropTypes.bool,
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let defaultStyle = {
            margin: "-20px auto",
            width: "100%",
            textAlign: "center",
        };
        let videoWrapperStyle = {
            height: "0",
            width: "100%",
            paddingBottom: "75%",
            position: "relative",
        };
        let videoStyle = {
            height: "100%",
            width: "100%",
            position: "absolute",
            top: "0",
            left: "0",
        };

        let defaultLandscapeStyle = {
            margin: "auto",
            width: "100%",
            textAlign: "center",
            //height: "0",
            paddingBottom: isPortrait ? "75%" : "auto",
            position: "relative",
            float: "right",
        };
        let hasPresenter =
            this.props.data.presenter !== undefined &&
            this.props.data.presenter.id !== "default43";
        let speechBubbleStyle = {
            position: "absolute",
            width: "100%",
            top: "-15px",
            left: "0",
            zIndex: "0",
            transform:
                hasPresenter && this.props.data.title === ""
                    ? "scaleY(-1)"
                    : "",
        };
        let captionStyle = {
            position: hasPresenter ? "absolute" : "relative",
            top: hasPresenter
                ? isPortrait
                    ? this.props.data.title === ""
                        ? "35%"
                        : "80%"
                    : "0"
                : "inherit",
            width: hasPresenter ? (isPortrait ? "60%" : "100%") : "90%",
            margin: isPortrait ? (hasPresenter ? "0" : "0 auto") : "20px auto",
            textAlign: "center",
            fontSize: isPortrait
                ? hasPresenter
                    ? "0.65em"
                    : "0.75em"
                : hasPresenter
                ? "0.65em"
                : "1.0em",
            padding: hasPresenter ? "0 30px 0 15px" : "0",
        };
        let title =
            this.props.data.header !== undefined
                ? this.props.data.header
                : this.props.data.title;
        let subtitle =
            this.props.data.subheader !== undefined
                ? this.props.data.subheader
                : this.props.data.subtitle;
        return (
            <div className="full-height">
                {isPortrait ? (
                    <div>
                        <SlideHeader
                            {...this.props}
                            title={title}
                            subtitle={subtitle}
                            largePresenter={this.props.data.title === ""}
                        />
                        <div style={defaultStyle}>
                            <div style={videoWrapperStyle}>
                                <div style={videoStyle}>
                                    <VideoBox
                                        url={this.props.data.video}
                                        autoplay={true}
                                        showFullScreenBtn={true}
                                    />
                                </div>
                            </div>
                            <div style={captionStyle}>
                                {hasPresenter &&
                                    this.props.data.caption &&
                                    this.props.data.caption.length <=
                                        ComponentInputs.caption.idealLength && (
                                        <img
                                            src="assets/images/speech_bubble2.png"
                                            alt="Speech bubble"
                                            style={speechBubbleStyle}
                                        />
                                    )}
                                <Caption
                                    keyName={"caption-" + this.props.slideId}
                                    text={this.props.data.caption}
                                    colors={this.props.colors}
                                    animation="transition.bounceUpIn,400,750"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <Grid style={{ minHeight: "100%" }}>
                        <Grid.Row style={{ paddingBottom: "0" }}>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingRight: "0",
                                    background: this.props.colors.primary,
                                }}
                            >
                                <SlideHeaderSidebar
                                    {...this.props}
                                    title={title}
                                    subtitle={subtitle}
                                />
                            </Grid.Column>
                            <Grid.Column width={8} style={{ paddingLeft: "0" }}>
                                <div style={defaultLandscapeStyle}>
                                    <div style={videoWrapperStyle}>
                                        <div style={videoStyle}>
                                            <VideoBox
                                                url={this.props.data.video}
                                                autoplay={true}
                                                showFullScreenBtn={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column
                                            width={hasPresenter ? 7 : 16}
                                        >
                                            <div style={captionStyle}>
                                                <Caption
                                                    keyName={
                                                        "caption-" +
                                                        this.props.slideId
                                                    }
                                                    text={
                                                        this.props.data.caption
                                                    }
                                                    colors={this.props.colors}
                                                    animation="transition.bounceUpIn,400,750"
                                                />
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </div>
        );
    }
}
